export const fetchHomeownerTimeline = (unitId: string) => ({
  promise: ({ client }: { client: any }) =>
    client.get(`/homeowners/units/${unitId}/timeline`),
});
